/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyBoxNew.vue?vue&type=template&id=cea3d742&scoped=true"
import script from "./luckyBoxNew.vue?vue&type=script&lang=js"
export * from "./luckyBoxNew.vue?vue&type=script&lang=js"
import style0 from "./luckyBoxNew.vue?vue&type=style&index=0&id=cea3d742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea3d742",
  null
  
)

export default component.exports